export const SITE = "https://mondearabe.org";
export const PLAN_ORDER = ["MA", "EG", "AE", "JO", "TN", "SA", "QA"];

export const CAPTIONS = {
  MA: {
    it: "Marrakech al tramonto, le luci di Jemaa el-Fnaa e l'Atlante innevato sullo sfondo. Il Marocco in un solo sguardo: storia, cucina, musica e una guida di viaggio pronta da stampare.",
    en: "Marrakech at sunset, the lanterns of Jemaa el-Fnaa and the snowy Atlas behind. Morocco at a glance: history, food, music and a printable travel guide.",
    fr: "Marrakech au coucher du soleil, les lanternes de Jemaa el-Fna et l'Atlas enneigé en toile de fond. Le Maroc en un regard : histoire, cuisine, musique et guide de voyage à imprimer.",
    ar: "مراكش عند الغروب، فوانيس جامع الفنا وجبال الأطلس المثلجة في الخلفية. المغرب في لمحة: تاريخ ومطبخ وموسيقى ودليل سفر جاهز للطباعة.",
    tags: "#Marocco #Morocco #Maroc #المغرب #Marrakech",
  },
  EG: {
    it: "Le piramidi di Giza hanno 4.500 anni e sono l'unica meraviglia del mondo antico ancora in piedi. Scopri l'Egitto: il Nilo, le ricette, il quiz delle bandiere e l'itinerario di 3 giorni.",
    en: "The pyramids of Giza are 4,500 years old — the only ancient wonder still standing. Discover Egypt: the Nile, recipes, the flag quiz and a 3-day itinerary.",
    fr: "Les pyramides de Gizeh ont 4 500 ans : la seule merveille antique encore debout. Découvrez l'Égypte : le Nil, les recettes, le quiz des drapeaux et un itinéraire de 3 jours.",
    ar: "عمر أهرامات الجيزة 4500 عام، وهي العجيبة القديمة الوحيدة الباقية. اكتشف مصر: النيل والوصفات واختبار الأعلام وبرنامج 3 أيام.",
    tags: "#Egitto #Egypt #Égypte #مصر #Giza",
  },
  AE: {
    it: "Dal deserto al Burj Khalifa in cinquant'anni. Gli Emirati raccontati con mappa interattiva, dati live, musica e consigli pratici per il tuo viaggio.",
    en: "From desert to Burj Khalifa in fifty years. The Emirates told through an interactive map, live data, music and practical travel tips.",
    fr: "Du désert au Burj Khalifa en cinquante ans. Les Émirats racontés avec une carte interactive, des données en direct, de la musique et des conseils pratiques.",
    ar: "من الصحراء إلى برج خليفة في خمسين عاماً. الإمارات بخريطة تفاعلية وبيانات حيّة وموسيقى ونصائح عملية لرحلتك.",
    tags: "#Emirati #UAE #Émirats #الإمارات #Dubai",
  },
  JO: {
    it: "Petra, scolpita nella roccia rosa più di 2.000 anni fa. La Giordania è nell'Atlante con il deserto del Wadi Rum, il Mar Morto e le frasi utili in arabo con audio.",
    en: "Petra, carved into rose rock more than 2,000 years ago. Jordan is in the Atlas with Wadi Rum, the Dead Sea and useful Arabic phrases with audio.",
    fr: "Pétra, taillée dans la roche rose il y a plus de 2 000 ans. La Jordanie dans l'Atlas : Wadi Rum, la mer Morte et des phrases utiles en arabe avec audio.",
    ar: "البتراء، منحوتة في الصخر الوردي قبل أكثر من 2000 عام. الأردن في الأطلس مع وادي رم والبحر الميت وعبارات مفيدة بالصوت.",
    tags: "#Giordania #Jordan #Jordanie #الأردن #Petra",
  },
  TN: {
    it: "Il bianco e blu di Sidi Bou Said, l'anfiteatro di El Jem e le dune del Sahara. La Tunisia è a due ore di volo: ecco la guida, i piatti e il kit viaggio offline.",
    en: "The white and blue of Sidi Bou Said, the El Jem amphitheatre and the Sahara dunes. Tunisia is a short flight away: guide, dishes and the offline travel kit.",
    fr: "Le blanc et bleu de Sidi Bou Saïd, l'amphithéâtre d'El Jem et les dunes du Sahara. La Tunisie à deux heures de vol : guide, plats et kit voyage hors ligne.",
    ar: "أبيض وأزرق سيدي بوسعيد، مدرج الجم وكثبان الصحراء. تونس على بعد ساعتين طيران: الدليل والأطباق وعدة السفر دون إنترنت.",
    tags: "#Tunisia #Tunisie #تونس #SidiBouSaid #Sahara",
  },
  SA: {
    it: "AlUla e le tombe di Hegra, la 'Petra saudita' aperta ai visitatori solo dal 2019. Scopri l'Arabia Saudita: storia, città simbolo e la Story del Paese in formato video.",
    en: "AlUla and the tombs of Hegra, the 'Saudi Petra' open to visitors only since 2019. Discover Saudi Arabia: history, landmark cities and the country Story in video.",
    fr: "AlUla et les tombes de Hégra, la « Pétra saoudienne » ouverte aux visiteurs depuis 2019 seulement. Découvrez l'Arabie saoudite : histoire, villes emblématiques et la Story du pays en vidéo.",
    ar: "العُلا ومقابر الحِجر، «بتراء السعودية» المفتوحة للزوار منذ 2019 فقط. اكتشف السعودية: التاريخ والمدن الرمزية وقصة البلد بالفيديو.",
    tags: "#ArabiaSaudita #SaudiArabia #ArabieSaoudite #السعودية #AlUla",
  },
  QA: {
    it: "Il Qatar è grande quanto l'Abruzzo ma ha costruito uno skyline da film. Museo d'Arte Islamica, Souq Waqif e dhow sulla Corniche: tutto nell'Atlante, in 4 lingue.",
    en: "Qatar is the size of a small region yet built a movie-set skyline. Museum of Islamic Art, Souq Waqif and dhows on the Corniche: all in the Atlas, in 4 languages.",
    fr: "Le Qatar est minuscule mais a bâti une skyline de cinéma. Musée d'art islamique, Souq Waqif et boutres sur la Corniche : tout dans l'Atlas, en 4 langues.",
    ar: "قطر صغيرة المساحة لكنها بنت أفقاً سينمائياً. متحف الفن الإسلامي وسوق واقف والمراكب على الكورنيش: كل ذلك في الأطلس بأربع لغات.",
    tags: "#Qatar #قطر #Doha #SouqWaqif",
  },
};

export const CTA = {
  it: "Esplora gratis 👉", en: "Explore for free 👉", fr: "Explorez gratuitement 👉", ar: "استكشف مجاناً 👈",
};
export const BRAND_TAGS = "#MondoArabo #ArabWorld #MondeArabe #العالم_العربي #Travel #Viaggi";

export const buildCaption = (code, lang, fmt) => {
  const c = CAPTIONS[code];
  const url = fmt === "fb"
    ? `${SITE}/api/share/${code}?lang=${lang}&banner=1&utm_source=facebook&utm_medium=social&utm_campaign=paesi`
    : `${SITE}/?c=${code}&lang=${lang}&utm_source=instagram&utm_medium=social&utm_campaign=paesi`;
  const link = fmt === "fb" ? `${CTA[lang]} ${url}` : `${CTA[lang]} link in bio · mondearabe.org`;
  return `${c[lang]}\n\n${link}\n\n${c.tags} ${BRAND_TAGS}`;
};

/** Two posts per country: Facebook then Instagram, on fixed weekdays from the start date. */
export const buildSchedule = (start, perWeek) => {
  const days = perWeek === 3 ? [1, 3, 5] : [2, 5];
  const slots = [];
  const d = new Date(start);
  d.setHours(10, 0, 0, 0);
  while (slots.length < PLAN_ORDER.length * 2) {
    if (days.includes(d.getDay())) slots.push(new Date(d));
    d.setDate(d.getDate() + 1);
  }
  return PLAN_ORDER.flatMap((code, i) => [{ code, fmt: "fb", at: slots[i * 2] }, { code, fmt: "ig", at: slots[i * 2 + 1] }]);
};

export const nextMonday = () => { const d = new Date(); d.setDate(d.getDate() + ((8 - d.getDay()) % 7 || 7)); return d.toISOString().slice(0, 10); };
